import styles from "./UserButton.module.css"
import { useEffect, useState, useRef } from 'react';
import { User } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import Popup from "../../Popup/Popup";
import { usePreferences } from "../../../context/PreferencesContext";
import { useTranslation } from "react-i18next";
import LanguageSwitch from "../../LanguageSwitch/LanguageSwitch";
import { useDropdown } from "../../../hooks/useDropdown";
/**
* Props for the UserButton component.
*/ 
interface UserButtonProps{
    LoggedIn: boolean, // Whether user is logged in
    logout: ()=>void // Logout event handler
}
/**
* Button with modal. Used in header.
* Contains links to multiple pages, language and currency switch and a logout modal.
*
* @param props UserButton props
* @param {boolean} props.LoggedIn - Whether user is logged in
* @param {() => void} props.logout - Logout event handler
* @returns TSX.Element
*/
const UserButton = ({ LoggedIn, logout }: UserButtonProps) => {
    const { t } = useTranslation(); // Translation
    const { selectedCurrency, setSelectedCurrency } = usePreferences(); // Selected currency and language
    const navigate = useNavigate(); // Navigate
    const [logoutOpen, setLogoutOpen] = useState<boolean>(false)
    const buttonRef = useRef<HTMLDivElement>(null);
    const { isOpen, setIsOpen, ref } = useDropdown();

    return(
        <>
            <div className={styles.UserCenter} ref={ref}>
            <div className={styles.User} onClick={()=> setIsOpen(!isOpen)} >
                <div className={styles.UserText}>
                    <p>{t("navbar.account")}</p>
                </div>
                <div className={styles.UserIcon}>
                    <User />
                </div>
            </div>
                {LoggedIn && isOpen && (
                    <div className={styles.Menu}  >
                        <div className={styles.MenuItem} onClick={()=> { navigate("/settings/user"); setIsOpen(false)}}>
                            <p>{t("navbar.pc.account")}</p>
                        </div>
                        <div className={styles.MenuItem} onClick={()=> {navigate("/settings/order"); setIsOpen(false)}}>
                            <p>{t("navbar.pc.orders")}</p>
                        </div>

                        <div className={styles.ButtonGroup}>
                            <div className={styles.ButtonGroupTitle}>
                                <p>
                                    {t("navbar.language")}
                                </p>
                            </div>
                            <LanguageSwitch type="pc"/>
                        </div>

                        <div className={styles.ButtonGroup}>
                            <div className={styles.ButtonGroupTitle}>
                                <p>
                                    {t("navbar.currency")}
                                </p>
                            </div>
                            <div className={styles.ButtonGroupOptions}>
                                <button className={`${styles.Option} ${selectedCurrency === "eur" ? styles.SelectedOption: ""}`} onClick={()=>setSelectedCurrency("eur")}>eur</button>
                                <button className={`${styles.Option} ${selectedCurrency === "czk" ? styles.SelectedOption: ""}`} onClick={()=>setSelectedCurrency("czk")}>czk</button>
                            </div>
                        </div>

                        <div className={styles.MenuItem} onClick={()=> {setLogoutOpen(true)}}>
                            <p>{t("navbar.logout")}</p>
                        </div>
                    </div>
                )}
                {!LoggedIn && isOpen && (
                    <div className={styles.Menu}  >
                        

                        <div className={styles.ButtonGroup}>
                            <div className={styles.SingleButtonGroupTitle}>
                                <p>
                                    {t("navbar.language")}
                                </p>
                            </div>
                            <LanguageSwitch type="pc"/>
                        </div>

                        <div className={styles.ButtonGroup}>
                            <div className={styles.ButtonGroupTitle}>
                                <p>
                                    {t("navbar.currency")}
                                </p>
                            </div>
                            <div className={styles.ButtonGroupOptions}>
                                <button className={`${styles.Option} ${selectedCurrency === "eur" ? styles.SelectedOption: ""}`} onClick={()=>setSelectedCurrency("eur")}>eur</button>
                                <button className={`${styles.Option} ${selectedCurrency === "czk" ? styles.SelectedOption: ""}`} onClick={()=>setSelectedCurrency("czk")}>czk</button>
                            </div>
                        </div>

                    </div>
                )}
            </div> 
            <Popup
                title={t("navbar.logout_popup_title")}
                onClose={()=>setLogoutOpen(false)}
                onSubmit={()=> {logout(); setIsOpen(false); setLogoutOpen(false);}}
                backBtnText={t("buttons.no")}
                submitBtnText={t("buttons.yes")}
                display={logoutOpen}
                className={styles.LogoutPopup}
                cardClassName={styles.LogoutPopupCard}
                />
        </>
    )
};

export default UserButton;